import { http } from "@/http";

// Plantillas de WhatsApp y su asignación por ciudad (DEF-ADM-025).
// No usa X-City-Id: las plantillas son configuración global, no de una ciudad.
export default {
  // --- Catálogo ---
  list(params) {
    return http.get("/api/v1/whatsapp-templates", { params });
  },
  get(id) {
    return http.get(`/api/v1/whatsapp-templates/${id}`);
  },
  // Trae el catálogo desde Twilio. Puede tardar unos segundos.
  sync() {
    return http.post("/api/v1/whatsapp-templates/sync");
  },
  // Clasifica la plantilla. templateType null la deja sin clasificar.
  classify(id, templateType) {
    return http.patch(`/api/v1/whatsapp-templates/${id}`, { template_type: templateType });
  },
  // Campos del viaje que se pueden poner en un {{N}}.
  fields() {
    return http.get("/api/v1/whatsapp-templates/fields");
  },

  // --- Configuración en bloque (el modal del admin) ---
  // Devuelve el tipo y las asignaciones agrupadas por dirección.
  getConfiguration(id) {
    return http.get(`/api/v1/whatsapp-templates/${id}/configure`);
  },
  // Aplica el mismo mapeo a todas las ciudades marcadas y quita las demás.
  configure(id, data) {
    return http.post(`/api/v1/whatsapp-templates/${id}/configure`, data);
  },

  // --- Asignaciones por ciudad (API granular; el modal usa configure) ---
  listMappings(params) {
    return http.get("/api/v1/whatsapp-templates/mappings", { params });
  },
  createMapping(data) {
    return http.post("/api/v1/whatsapp-templates/mappings", data);
  },
  updateMapping(id, data) {
    return http.put(`/api/v1/whatsapp-templates/mappings/${id}`, data);
  },
  deleteMapping(id) {
    return http.delete(`/api/v1/whatsapp-templates/mappings/${id}`);
  },
};
